export default __webpack_public_path__ + "static/Live_Cams_01-a8b7c1c54acdee447dff442b6a3f08c8.webp";